/** English + Hebrew UI strings for Mu Beginning website */

export const translations = {
  en: {
    // Lang bar
    lang_hebrew: "HEBREW",
    lang_english: "ENGLISH",

    // Hero
    play_now: "PLAY NOW",
    download_client: "DOWNLOAD CLIENT",

    // Auth login
    account_login: "Account Login",
    username: "Username",
    password: "Password",
    sign_in: "Sign In",

    // Register
    registration: "Registration",
    choose_profile_picture: "Choose your profile picture",
    confirm_password: "Confirm Password",
    email_address: "Email Address",
    agree_rules_prefix: "I agree to the",
    server_rules_link: "server rules",
    create_account: "Create Account",
    server_rules_title: "Mu Beginning — Server Rules",

    // My Account / sidebar
    my_account: "My Account",
    account_details: "Account Details",
    buy_bcoin: "Buy BCoin",
    my_characters: "My Characters",
    logout: "Logout",
    account_status: "Account Status",
    banned: "Banned",
    active: "Active",
    online_status: "Online Status",
    online: "Online",
    offline: "Offline",
    characters: "Characters",
    change_password: "Change Password",
    change_email: "Change Email",

    // Characters table
    col_name: "Name",
    col_player: "Player",
    col_level: "Level",
    top_players: "Top Players",
    col_resets: "Resets",
    col_reset: "Reset",
    col_strength: "Strength",
    col_agility: "Agility",
    col_vitality: "Vitality",
    col_energy: "Energy",
    col_status: "Status",
    no_characters: "No characters yet...",

    // Character options
    character_options: "Character Options",
    back_to_characters: "← Back to Characters",
    game_master: "Game Master",
    player: "Player",
    level_resets: "Level {level} · Resets {resets}",
    character_not_found: "Character not found.",
    add_stats: "Add Stats",
    reset_character: "Reset Character",
    clear_pk: "Clear PK",

    // Add stats
    points: "Points",
    strength: "Strength",
    dexterity: "Dexterity",
    vitality: "Vitality",
    energy: "Energy",
    command: "Command",
    send: "Send",
    max_points: "Max Points 32767",

    // Change password / email
    your_email: "Your email",
    new_password: "New password",
    confirm_new_password: "Confirm new password",
    update: "Update",
    updating: "Updating...",
    cancel: "Cancel",
    current_email: "Current email",
    new_email: "New email",
    confirm_new_email: "Confirm new email",
    password_verify: "Password (verify identity)",

    // Events
    events_schedule: "EVENTS SCHEDULE",
    events_subtitle:
      "Live countdown to next start (synced with in-game Event Time)",
    event_col_name: "Event Name",
    event_col_starts: "Starts In",
    loading_events: "Loading events…",

    // Ranking
    player_rankings: "Player Rankings",
    search_player: "Search player",
    search: "Search",

    // Guilds
    top_guilds: "Top Guilds",
    col_guild: "Guild",
    col_master: "Master",
    col_members: "Members",
    col_score: "Score",
    score_label: "Score: {score}",
    back_to_home: "← Back to Home",

    // Download
    download_title: "Full Client Download",
    download_description: "Latest client package",
    download_now: "Download Now",

    // Guides
    guides: "Guides",
    select_a_guide: "Select a guide",
    choose_guide_topic: "Choose a topic from the list to read the guide.",

    // Rules body (English — used when lang=en)
    rules_body: `MU Beginning — Server Rules

This document is a binding agreement between Mu Beginning administration and every user of the website, game server, and/or official Discord.

Using the site, game, or Discord means full acceptance of these rules.

1. General
1.1 These rules apply to all activity on the game server and official Discord.
1.2 Not knowing the rules does not excuse violations.
1.3 Administration may enforce rules at its sole discretion.

2. Conduct
2.1 Insults, harassment, and humiliation of other users are forbidden.
2.2 Severe insults may result in mute up to one week.
2.3 Impersonation of players or staff may result in permanent ban.

3. Advertising & Content
3.1 Only Mu-related content is allowed in designated channels.
3.2 Advertising competing servers/communities is forbidden.
3.3 Sexual / pornographic content is forbidden.

4. Hacks, Bots & Illegal Software
4.1 Using, trading, or promoting hacks/bots is strictly forbidden.
4.2 Violation may result in permanent ban without compensation.

5. Staff Authority
5.1 Follow staff instructions at all times.
5.2 Contact staff via official tickets / designated channels only.

6. Trading
6.1 Real-money trading of items/characters/credits is forbidden.
6.2 In-game trade must follow designated channels and server rules.

7. Gambling
7.1 Gambling in Discord and/or game is forbidden unless part of an official event.

8. PvP / PK
8.1 This is a PvP server; staff do not intervene in normal PK conflicts.
8.2 Respectful behavior is still required.

9. Discord
9.1 Alt accounts, spam, and flooding are forbidden.

10. Age, Purchases & Liability
10.1 User declares age of 18+, or guardian approval.
10.2 Purchased products are virtual and for gameplay only.
10.3 No refunds for loss caused by password sharing, public networks, trades, or shared PCs.

11. Refunds
11.1 Product not delivered within 24 hours — full refund.
11.2 Server closure: up to 30 days full refund; up to 60 days 50%; after 60 days none.

12. Sanctions
12.1 Administration may restrict or ban users at its discretion without refund.
12.2 Rules and systems may change at any time.

Last updated: 19.09.2025
Mu Beginning Administration`,
  },

  he: {
    lang_hebrew: "עברית",
    lang_english: "ENGLISH",

    play_now: "שחק עכשיו",
    download_client: "הורד קליינט",

    account_login: "כניסה לחשבון",
    username: "שם משתמש",
    password: "סיסמה",
    sign_in: "התחבר",

    registration: "הרשמה",
    choose_profile_picture: "בחר תמונת פרופיל",
    confirm_password: "אימות סיסמה",
    email_address: "כתובת אימייל",
    agree_rules_prefix: "אני מסכים ל",
    server_rules_link: "חוקי השרת",
    create_account: "צור חשבון",
    server_rules_title: "Mu Beginning — Server Rules",

    my_account: "החשבון שלי",
    account_details: "פרטי חשבון",
    buy_bcoin: "קנה BCoin",
    my_characters: "הדמויות שלי",
    logout: "התנתק",
    account_status: "סטטוס חשבון",
    banned: "חסום",
    active: "פעיל",
    online_status: "סטטוס אונליין",
    online: "מחובר",
    offline: "מנותק",
    characters: "דמויות",
    change_password: "שנה סיסמה",
    change_email: "שנה אימייל",

    col_name: "שם",
    col_player: "שחקן",
    col_level: "רמה",
    top_players: "שחקנים מובילים",
    col_resets: "ריסטים",
    col_reset: "ריסט",
    col_strength: "כוח",
    col_agility: "זריזות",
    col_vitality: "חיים",
    col_energy: "אנרגיה",
    col_status: "סטטוס",
    no_characters: "אין דמויות עדיין...",

    character_options: "אפשרויות דמות",
    back_to_characters: "← חזרה לדמויות",
    game_master: "Game Master",
    player: "שחקן",
    level_resets: "רמה {level} · ריסטים {resets}",
    character_not_found: "הדמות לא נמצאה.",
    add_stats: "הוסף סטאטים",
    reset_character: "ריסט לדמות",
    clear_pk: "נקה PK",

    points: "נקודות",
    strength: "כוח",
    dexterity: "זריזות",
    vitality: "חיים",
    energy: "אנרגיה",
    command: "פיקוד",
    send: "שלח",
    max_points: "מקסימום נקודות 32767",

    your_email: "האימייל שלך",
    new_password: "סיסמה חדשה",
    confirm_new_password: "אימות סיסמה חדשה",
    update: "עדכן",
    updating: "מעדכן...",
    cancel: "ביטול",
    current_email: "אימייל נוכחי",
    new_email: "אימייל חדש",
    confirm_new_email: "אימות אימייל חדש",
    password_verify: "סיסמה (לאימות זהות)",

    events_schedule: "לוח אירועים",
    events_subtitle: "ספירה לאחור לאירוע הבא (מסונכרן עם Event Time במשחק)",
    event_col_name: "שם האירוע",
    event_col_starts: "מתחיל בעוד",
    loading_events: "טוען אירועים…",

    player_rankings: "דירוג שחקנים",
    search_player: "חיפוש שחקן",
    search: "חפש",

    top_guilds: "גילדות מובילות",
    col_guild: "גילדה",
    col_master: "מאסטר",
    col_members: "חברים",
    col_score: "ניקוד",
    score_label: "ניקוד: {score}",
    back_to_home: "← חזרה לדף הבית",

    download_title: "הורדת קליינט מלא",
    download_description: "חבילת הקליינט העדכנית",
    download_now: "הורד עכשיו",

    guides: "מדריכים",
    select_a_guide: "בחר מדריך",
    choose_guide_topic: "בחר נושא מהרשימה כדי לקרוא את המדריך.",

    rules_body: `MU Beginning — Server Rules

מסמך זה הוא הסכם מחייב בין הנהלת Mu Beginning לבין כל משתמש באתר, בשרת המשחק ו/או בדיסקורד הרשמי.

שימוש באתר, במשחק או בדיסקורד מהווה הסכמה מלאה לכללים אלה.

1. כללי
1.1 הכללים חלים על כל פעילות בשרת המשחק ובדיסקורד הרשמי.
1.2 אי־ידיעת הכללים אינה פוטרת מהפרות.
1.3 ההנהלה רשאית לאכוף את הכללים לפי שיקול דעתה הבלעדי.

2. התנהגות
2.1 אסורים עלבונות, הטרדות והשפלות של משתמשים אחרים.
2.2 עלבונות חמורים עלולים להוביל להשתקה עד שבוע.
2.3 התחזות לשחקנים או לצוות עלולה להוביל לחסימה קבועה.

3. פרסום ותוכן
3.1 מותר רק תוכן הקשור ל־Mu בערוצים הייעודיים.
3.2 אסור לפרסם שרתים/קהילות מתחרים.
3.3 אסור תוכן מיני / פורנוגרפי.

4. האקים, בוטים ותוכנות לא חוקיות
4.1 שימוש, מסחר או קידום האקים/בוטים אסורים לחלוטין.
4.2 הפרה עלולה להוביל לחסימה קבועה ללא פיצוי.

5. סמכות הצוות
5.1 יש לפעול לפי הוראות הצוות בכל עת.
5.2 פנייה לצוות רק דרך טיקטים רשמיים / ערוצים ייעודיים.

6. מסחר
6.1 אסור מסחר בכסף אמיתי של פריטים/דמויות/קרדיטים.
6.2 מסחר במשחק חייב לעמוד בערוצים ובכללי השרת.

7. הימורים
7.1 הימורים בדיסקורד ו/או במשחק אסורים אלא אם זה חלק מאירוע רשמי.

8. PvP / PK
8.1 זהו שרת PvP; הצוות לא מתערב בסכסוכי PK רגילים.
8.2 עדיין נדרשת התנהגות מכבדת.

9. דיסקורד
9.1 חשבונות אלט, ספאם והצפה אסורים.

10. גיל, רכישות ואחריות
10.1 המשתמש מצהיר על גיל 18+, או אישור אפוטרופוס.
10.2 מוצרים שנרכשו הם וירטואליים ולצורכי משחק בלבד.
10.3 אין החזרים על אובדן עקב שיתוף סיסמה, רשתות ציבוריות, עסקאות או מחשבים משותפים.

11. החזרים
11.1 מוצר שלא סופק תוך 24 שעות — החזר מלא.
11.2 סגירת שרת: עד 30 יום החזר מלא; עד 60 יום 50%; לאחר 60 יום אין החזר.

12. סנקציות
12.1 ההנהלה רשאית להגביל או לחסום משתמשים לפי שיקול דעתה ללא החזר.
12.2 הכללים והמערכות עשויים להשתנות בכל עת.

עודכן לאחרונה: 19.09.2025
הנהלת Mu Beginning`,
  },
};

/** Guides tab labels (category / topic) — Hebrew only overrides by id */
export const guidesHe = {
  basic: { title: "מידע בסיסי", subtitle: "יסודות השרת" },
  classes: { title: "מחלקות", subtitle: "בניית דמויות" },
  systems: { title: "מערכות", subtitle: "פיצ'רים בשרת" },
  leveling: { title: "התקדמות ורמות", subtitle: "גדל מהר יותר" },
  events: { title: "אירועים", subtitle: "תוכן מתוזמן" },

  welcome: "ברוכים הבאים ל־Mu Beginning",
  "game-options": "אפשרויות משחק (הגדרות)",
  "game-options-game-tab": "לשונית משחק — שליטה ותצוגה",
  "game-options-graphics-tab": "לשונית גרפיקה — ביצועים וסאונד",
  helper: "עוזר MU",
  interface: "ממשק המשחק",

  dw: "Dark Wizard (DW)",
  dk: "Dark Knight (DK)",
  fe: "Fairy Elf / Muse Elf (FE)",
  mg: "Magic Gladiator (MG)",
  dl: "Dark Lord (DL)",
  su: "Summoner (SU)",
  rf: "Rage Fighter (RF)",

  "battle-pass": "Battle Pass",
  dungeons: "מערכת מבוכים",
  vip: "מערכת VIP",
  "fenrir-mix": "Fenrir Mix",
  reset: "מערכת ריסט",
  "grand-reset": "Grand Reset",
  voice: "צ'אט קולי",
  quests: "מערכות קווסטים",
  market: "מערכת שוק",
  "expanded-inventory": "אינבנטורי מורחב",
  "online-bonus": "בונוס אונליין",

  spots: "מקומות אימון",
  progression: "התקדמות מומלצת",

  // Event names stay English
  "blood-castle": "Blood Castle",
  "devil-square": "Devil Square",
  "chaos-castle": "Chaos Castle",
  kanturu: "Kanturu Event",
  kalima: "Kalima Kundun",
  imperial: "Imperial Guardian",
  illusion: "Illusion Temple",
  invasions: "World Invasions",
  "boss-together": "Boss Battle Together",
  "arka-war": "Arka War",
  "other-events": "Other Events",
};
